import { actionTree, getterTree, mutationTree } from 'typed-vuex'
import type { LocationAsRelativeRaw, RouteLocationOptions, RouteQueryAndHash } from 'vue-router'

import router from '@/router'

type SetErrorMessagePayload = { message: string; }

type RouteLocationRaw = (RouteQueryAndHash & RouteLocationOptions) | (RouteQueryAndHash & LocationAsRelativeRaw & RouteLocationOptions)
type Go404Payload = RouteLocationRaw & Partial<SetErrorMessagePayload>

export const state = () => ({
  message: '',
})

export const getters = getterTree(state, {
  message: (state) => state.message,
})

export const mutations = mutationTree(state, {

  /**
   * 设置404页面的错误信息
   */
  setErrorMessage (ctx, payload: SetErrorMessagePayload) {
    ctx.message = payload.message
  },

  clearErrorMessage (ctx) {
    if (ctx.message) {
      ctx.message = ''
    }
  },
})

export const actions = actionTree({ mutations, state, getters }, {
  /**
   * 跳去404页面
   */
  go404 (ctx, payload: Go404Payload) {
    const { message, ...raw } = payload

    if (message) {
      ctx.commit('setErrorMessage', { message })
    }

    router.push({
      path: '/404',
      replace: true,
      ...raw,
    })
  },
})

export const namespaced = true
